// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TnPQC","top":"styles_top__3bnxS"};